import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { LoginRequest, User } from '../../domain/models/user'
import type { ILogin } from '../../domain/use-cases/i-login'
import type { ILoginClient } from '../data-sources/i-login-client'

export class LoginRepository implements ILogin {
  constructor(private readonly dataSource: ILoginClient) {}
  async login(params: LoginRequest): Promise<User> {
    const result = await this.dataSource.login(params)

    if (
      result.status !== HttpStatusCode.OK &&
      result.status !== HttpStatusCode.PRECONDITION_REQUIRED
    ) {
      throw new Exception(result.status, result?.message!)
    }

    if (result.status === HttpStatusCode.PRECONDITION_REQUIRED)
      throw result.message

    return result.data
  }
}
